import React from 'react';
import { useSelector } from '@xstate/react';
import { Modal, useModalVariant } from '@chargify/custom-ui-components';

import { Content } from './components';

import { useServices } from '../../hooks';
import { modalsSelectors } from '../../machines';

const ComponentsAllocation = () => {
  const { modalsService } = useServices();
  const modalVariant = useModalVariant();

  const { isOpen, meta } = useSelector(
    modalsService,
    modalsSelectors.getAddonsConfiguration
  );

  const closeHandler = () => modalsService.send({ type: 'CLOSE_MODAL' });

  return (
    <Modal
      isOpen={isOpen}
      onClose={closeHandler}
      variant={modalVariant}
      width="100%"
    >
      <Content {...meta} displayMode={modalVariant} onClose={closeHandler} />
    </Modal>
  );
};

export default ComponentsAllocation;
